export default __webpack_public_path__ + "static/media/PK.41029e27.svg";